export default __webpack_public_path__ + "static/media/2092.e69c11ae.png";